import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS8() {
    window.scrollTo(0,0);
    return (
        <div className="container">
             <img src="/images/clrhs8.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS8
